import React from 'react';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import {
  mapUrlWithDtmLinkQuery,
  sendDTMClickEvent
} from 'service_modules/models/dtm-tagging';
import styles from './__styles__/index.scss?modules';

const CardUnit = ({
  cardTitle,
  cardArtUrl,
  cardArtAltText,
  learnMoreUrl,
  unitDtm
}) => {
  const hrefVal = mapUrlWithDtmLinkQuery(learnMoreUrl, unitDtm);

  const tileClickHandler = () => {
    sendDTMClickEvent(unitDtm);
  };

  return (
    <a className={styles.cardItem} href={hrefVal} onClick={tileClickHandler}>
      <img className={styles.cardArt} src={cardArtUrl} alt={cardArtAltText} />
      <Sanitizer
        className={styles.title}
        Component="span"
        aria-hidden="true" //need to hide this text from the screen reader as the alt text of the image is more descriptive
        safelySetInnerHTML={cardTitle}
      />
    </a>
  );
};

export default React.memo(CardUnit);
